import {
  Button,
  Grid,
  Paper,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getPreAuthTableData } from "../../action";
import Dropdown from "../../reusableComponents/components/generics/Dropdown";

const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));

function PreAuthFilter() {
  const { t } = useTranslation();
  const [dropValue, setDropValue] = useState(0);
  const [showCalendar, setShowCalendar] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [label, setLabel] = useState("Enter CAMU No.");
  const SignInSuccess = useSelector((state) => state);
  let healthData = SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0];
  const dispatch = useDispatch();

  const handleChange = (event) => {
    const value = event.target.value;
    console.log(value);
    setDropValue(value);
    getLabel(value);
    // setShowCalendar(value === '3');
  };

  const handleSearch = () => {
    let params = buildQueryParams({
      filters: {},

      first: 10,
    });
    dispatch(getPreAuthTableData(params));
  };

  const handleClear = () => {
    setSearchValue("");
    let params = buildQueryParamsClear({
      filters: {},

      first: 10,
    });
    dispatch(getPreAuthTableData(params));
  };

  const buildQueryParamsClear = (state) => {
    let params = Object.keys(state.filters)
      .filter((f) => !!state.filters[f]["filter"])
      .map((f) => state.filters[f]["filter"]);
    if (!!state.orderBy) {
      params.push(`orderBy: ["${state.orderBy}"]`);
    }
    if (!!state.first) {
      params.push(`first: ${state.first}`);
    }
    if (!!healthData) {
      params.push(`healthFacility_Uuid: "${healthData?.uuid}"`);
    }
    return params;
  };

  const buildQueryParams = (state) => {
    let params = Object.keys(state.filters)
      .filter((f) => !!state.filters[f]["filter"])
      .map((f) => state.filters[f]["filter"]);
    if (searchValue) {
      if (dropValue == 1) {
        params.push(`insuree_CamuNumber_Icontains: "${searchValue}"`);
      }
      if (dropValue == 2) {
        params.push(`code_Icontains: ${searchValue}`);
      }
      if (dropValue == 3) {
        let searchVal = parseInt(searchValue);
        params.push(`status: ${searchVal}`);
      }
    }
    // if (!!state.orderBy) {
    //     params.push(`orderBy: ["${state.orderBy}"]`);
    // }
    if (!!state.first) {
      params.push(`first: ${state.first}`);
    }

    if (!!healthData) {
      params.push(`healthFacility_Uuid: "${healthData?.uuid}"`);
    }
    return params;
  };

  const getLabel = (value) => {
    switch (value) {
      case 1:
        setLabel("EnterClaimNo.");
        break;
      case 2:
        setLabel("Requestno");
        break;
      case 3:
        setLabel("Status");
        break;
      default:
        setLabel("byStatus");
        break;
    }
  };

  const searchType = [
    {
      value: 1,
      label: t("camuNo"),
    },
    {
      value: 2,
      label: t("RequestNo"),
    },
    {
      value: 3,
      label: t("Status"),
    },
  ];

  const statusDropList = [
    {
      value: "-1",
      label: t("Rejected"),
    },
    {
      value: "1",
      label: t("Created"),
    },
    {
      value: "2",
      label: t("Waiting for Approval"),
    },
    {
      value: "3",
      label: t("Rework"),
    },
    {
      value: "4",
      label: t("Approved"),
    },
  ];

  const claimStatus = [
    {
      value: "1",
      label: t("Rejected"),
    },
    {
      value: "2",
      label: t("Created"),
    },
    {
      value: "4",
      label: t("Submitted"),
    },
    {
      value: "8",
      label: t("Processed"),
    },
    {
      value: "16",
      label: t("Approved"),
    },
    {
      value: "32",
      label: t("Rework"),
    },
    {
      value: "64",
      label: t("Paid"),
    },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <StyledPaper>
          <StyledPaperHeader>
            <Grid item alignItems="center">
              <Typography variant="h6">{t("Search Criteria")}</Typography>
            </Grid>
          </StyledPaperHeader>
          <Form
            autoComplete="off"
            onSubmit={(values) => {
              console.log(values);
            }}
            render={({ handleSubmit, form }) => (
              <form onSubmit={handleSubmit}>
                <Grid
                  style={{
                    display: "flex",
                    marginLeft: ".5rem",
                    marginTop: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  <Grid item xs={3} className="common-input">
                    <Typography color="#000" fontSize="14">
                      {t("Search Criteria")}
                    </Typography>
                    <Field
                      name="typeOfSearch"
                      component={Dropdown}
                      options={searchType}
                      input={{ value: dropValue, onChange: handleChange }}
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input">
                    {dropValue !== 0 && (
                      <Typography color="#000" fontSize="24">
                        {t(label)}
                      </Typography>
                    )}
                    {(dropValue === 1 || dropValue === 2) && (
                      <TextField
                        name="name"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        size="small"
                        type="text"
                        autoComplete="off"
                      />
                    )}
                    {dropValue === 3 && (
                      <Field
                        name="claimType"
                        component={Dropdown}
                        options={statusDropList}
                        input={{
                          value: searchValue,
                          onChange: (e) => setSearchValue(e.target.value),
                        }}
                      />
                    )}
                  </Grid>
                  {dropValue !== 0 && (
                    <Grid
                      item
                      xs={8}
                      style={{ display: "flex", marginTop: "1.4rem" }}
                    >
                      <Grid item xs={3} className="common-input">
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleSearch}
                        >
                          {t("Search")}
                        </Button>
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={handleClear}
                          style={{ marginLeft: "1rem" }}
                        >
                          {t("Clear")}
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </form>
            )}
          />
        </StyledPaper>
      </Grid>
    </Grid>
  );
}

export default PreAuthFilter;
